import { generateOptions } from '@/lib/generic.utils'
import { LmConfirmDialogData } from '@/lib/models/lm-confirm-dialog-data.class'

export default {
  updateAccessToken(state, value) {
    state.accessToken = value
  },
  updateCustomer(state, value) {
    state.customer = value
  },
  updateUser(state, value) {
    state.user = value
  },
  updateRequestCancellationToken(state, value) {
    state.requestCancellationToken = value
  },
  updateTenant(state, value) {
    state.tenant = value
  },
  updateGlobalLoader(state, value) {
    state.globalLoader = value
  },
  updateSettings(state, data) {
    let settingsOptions = { ...state.settings.options }
    // Set currency options
    if (data.options && data.options.currencies) {
      if (!settingsOptions.featuredCurrencies.includes(data.currency)) {
        settingsOptions.featuredCurrencies.push(data.currency)
      }
      let currencyOptions = generateOptions({
        collection: settingsOptions.featuredCurrencies,
        labelKey: null,
        valueKey: null,
        sort: false
      })
      data.options.currencies.forEach(item => {
        if (!currencyOptions.find(currency => currency.value === item.value)) currencyOptions.push(item)
      })
      currencyOptions[settingsOptions.featuredCurrencies.length].separator = true
      settingsOptions.currencies = currencyOptions
      delete data.options.currencies
    }
    // Set country options
    if (data.options && data.options.countries) {
      settingsOptions.countries = generateOptions({
        collection: data.options.countries,
        labelKey: null,
        valueKey: null,
        sort: false
      })
      delete data.options.countries
    }
    // Set users options
    if (data.options && data.options.users) {
      settingsOptions.users = generateOptions({
        collection: data.options.users,
        labelKey: 'name',
        valueKey: 'id'
      })
      delete data.options.users
    }
    // Cleanup
    if (data.options && Object.keys(data.options).length) {
      settingsOptions = { ...settingsOptions, ...data.options }
    } else {
      delete data.options
    }
    state.settings = { ...state.settings, ...data }
    state.settings.options = Object.assign({}, state.settings.options, settingsOptions)
  },
  updateFinancialPeriodStartMonth(state, monthValue) {
    state.settings.financial_period_start_month = monthValue
  },
  updateChartRolloverDate(state, newDate) {
    state.settings.chart_date_switch = newDate
  },
  updateMemberSettings(state, data) {
    let settingsOptions = { ...state.settings.options }
    state.settings = { ...state.settings, ...data }
    state.settings.options = Object.assign({}, state.settings.options, settingsOptions)
  },
  updateGlobalDialogVisibility(state, params) {
    let obj = {}
    obj[params.uid] = params.value
    state.globalDialogVisible = Object.assign({}, state.globalDialogVisible, obj)
  },
  updateGlobalDialogContent(state, params) {
    let obj = {}
    obj[params.uid] = new LmConfirmDialogData(params.value)
    state.globalDialogContent = Object.assign({}, state.globalDialogContent, obj)
  },
  setEmailPreferences: (state, payload) => (state.emailPreferences = payload),
  setSettingsFetched: (state, payload) => (state.settingsFetched = payload),
  setLoader: (state, payload) => (state.loader = payload)
}
